<template>
  <div id="grafana-dashboard" class="col-lg-12"></div>
</template>
<script type="text/javascript">
GrafanaEmbed = {
  grafanaUrl: "https://insights.aiab.in",
  dashboard: "dashboad-name",
  queryParams: {
    dashnav: 0,
    // this is a base64-encoded string of username:password
    // for example on a *NIX machine (and Mac OS X):
    // $ echo "kiosk1:supersecret" | base64
    // a2lvc2sxOnN1cGVyc2VjcmV0Cg==
    auth: "dGVzdEAxMjM6VGVzdEAxMjM=", //base64 encoded for test@123:Test@123
    theme: "light",
  },
};
(function () {
  var d = document.createElement("script");
  d.type = "text/javascript";
  d.async = true;
  d.src = GrafanaEmbed.grafanaUrl + "/public/app/features/dashboard/embed.js";
  (
    document.getElementsByTagName("head")[0] ||
    document.getElementsByTagName("body")[0]
  ).appendChild(d);
})();
</script>
